import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getMembers } from './helpers'
import HolidayTipsItem from './HolidayTipsItem'

const HolidayTipsBody = ({ setMember }) => {
  const { t } = useTranslation(['holiday-tips'])
  return (
    <div className="holiday-tips__body">
      {getMembers(t).map((member) => (
        <HolidayTipsItem key={member.id} {...member} setMember={setMember} />
      ))}
    </div>
  )
}

HolidayTipsBody.propTypes = {
  setMember: PropTypes.func.isRequired,
}

export default HolidayTipsBody
